import { Text } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Card, Col, List, Row } from 'antd'
import { ArrowLeft, ArrowRight } from 'iconsax-react'

import { UniqueFields } from '../pages'

type Props = {
  title: string
  checkList: UniqueFields
  selectedList: UniqueFields
  onToggle: (name: string) => void
}

export const DuplicateFieldsBlock = ({
  title,
  checkList,
  selectedList,
  onToggle
}: Props) => {
  const { t } = useLocales()

  return (
    <Card title={title}>
      <Row gutter={16}>
        <Col span={12}>
          <List
            header={t('import.fields_to_check')}
            dataSource={checkList}
            renderItem={(item) => {
              const isDisabled = item.column_index === -1

              return (
                <List.Item
                  onClick={() => {
                    if (isDisabled) return
                    onToggle(item.name)
                  }}
                  className="pointer"
                >
                  <Text disabled={isDisabled}>{item.name}</Text>
                  <ArrowRight />
                </List.Item>
              )
            }}
          />
        </Col>

        <Col span={12}>
          <List
            header={t('import.available_fields')}
            dataSource={selectedList}
            renderItem={(item) => (
              <List.Item
                onClick={() => onToggle(item.name)}
                className="pointer"
              >
                <ArrowLeft />
                <Text>{item.name}</Text>
              </List.Item>
            )}
          />
        </Col>
      </Row>
    </Card>
  )
}
